export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const FB_API_KEY = process.env.REACT_APP_FB_API_KEY;
export const FB_AUTH_DOMAIN = process.env.REACT_APP_FB_AUTH_DOMAIN;
export const FB_PROJECT_ID = process.env.REACT_APP_FB_PROJECT_ID;
export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID;
export const FB_DATABASE_URL = process.env.REACT_APP_FB_DATABASE_URL;
export const LANDING_PAGE_URL = process.env.REACT_APP_LANDING_PAGE_URL || '';
